export const ListingsList = {};

export const ListingsCardDeck = {
  marginX: -2,
};
